import { ApiClient } from '@/infra/api-client'

/**
 * HubSpot tracking API.
 */
export class HubSpotTrackingApi extends ApiClient {
  /**
   * Gets the HubSpot tracking token for the current user.
   *
   * @param signal
   */
  getCurrentUserHubSpotTrackingToken(signal?: AbortSignal): Promise<string> {
    return this._get('hubspot-tracking', undefined, { signal })
  }
}
